import "./WhyLanding.scss";

import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";
import { baseUrl } from "../../../utils/apiData";
import { useNavigate } from "react-router-dom";

const WhyLanding = ({ title, des, image, btnName }) => {
  const navigate = useNavigate();

  return (
    <section className="why_landing">
      <div className="content_wrap p_top p_bottom">
        <div className="text_content">
          <h2 className="wow fadeInUp" style={{ color: "#fff" }}>
            {title}
          </h2>
          <p className="wow fadeInUp" data-wow-delay="0.1s">
            {des}
          </p>
          <ArrowBtn
            text={btnName}
            theme="secondary_ternery"
            handleClick={() => navigate("/contactus")}
            classList="wow fadeInUp"
          />
        </div>
        <div className="img_wrap">
          <img src={`${baseUrl}/${image}`} alt="img" />
        </div>
      </div>
    </section>
  );
};

export default WhyLanding;
